(() => {

  const GRID_SELECTOR =
    '#cart-drawer .sbc-cart-curation__grid';

  let timer = null;
  let running = false;


  const PRODUCT_COPY = {

    weekender:
      'Geniş hacmi ve güçlü formuyla günlük kullanım ve kısa yolculuklara eşlik eder.',

    moment:
      'Kompakt formu ve farklı taşıma seçenekleriyle günün farklı ritimlerine uyum sağlar.',

    aven:
      'Geniş hacimli sırt çantası formuyla şehir hayatında konfor ve karakteri bir araya getirir.',

    'aven-c':
      'Geniş hacimli sırt çantası formuyla şehir hayatında konfor ve karakteri bir araya getirir.',

    grace:
      'Hafif ve kompakt yapısıyla gündüzden akşama sade bir zarafet taşır.',

    mirabilis:
      'Geniş hacmi ve çoklu bölmeleriyle günlük kullanım ve yolculuk arasında rahatça geçiş yapar.',

    mini:
      'Kompakt omuz formuyla günlük stile sade ama güçlü bir dokunuş ekler.',

    sempre:
      'Geniş iç hacmi ve deri ile süetin birlikteliğiyle zamansız bir günlük eşlikçidir.',

    aura:
      'Zarif formu ve farklı taşıma seçenekleriyle güçlü ama rafine bir duruş sunar.',

    voyage:
      'Geniş hacmi ve güçlü formuyla yolculuklar için karakterli bir alternatif sunar.',

    tityos:
      'Geniş iç hacmi ve bölmeleriyle günlük düzeni güçlü bir silüetle buluşturur.',

    momo:
      'Geniş hacmi, çoklu bölmeleri ve rahat askısıyla yoğun günlük ritimlere eşlik eder.'

  };


  function money(cents) {

    return (
      new Intl.NumberFormat(
        'tr-TR',
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      ).format(
        Number(cents || 0) / 100
      ) +
      ' TL'
    );

  }


  async function getCart() {

    const response =
      await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          cache: 'no-store'
        }
      );


    if (!response.ok) {
      throw new Error('Cart okunamadı');
    }


    return response.json();

  }


  async function getRecommendations(productId) {

    const url =
      `${window.Shopify.routes.root}recommendations/products.json` +
      `?product_id=${encodeURIComponent(productId)}` +
      `&limit=8` +
      `&intent=related`;


    const response =
      await fetch(
        url,
        {
          cache: 'no-store'
        }
      );


    if (!response.ok) {
      return [];
    }


    const data =
      await response.json();


    return Array.isArray(data.products)
      ? data.products
      : [];

  }


  function description(product) {

    const handle =
      String(product.handle || '')
        .toLowerCase();


    if (PRODUCT_COPY[handle]) {
      return PRODUCT_COPY[handle];
    }


    const title =
      String(product.title || '')
        .toLowerCase();


    const key =
      Object.keys(PRODUCT_COPY)
        .find(
          handleKey =>
            title.includes(
              handleKey.replace('-', ' ')
            )
        );


    if (key) {
      return PRODUCT_COPY[key];
    }


    return (
      'SoulByChi koleksiyonunun doğal malzeme ve zamansız form anlayışını taşıyan karakterli bir parça.'
    );

  }


  function imageUrl(product) {

    let image =
      product.featured_image;


    if (!image) {
      return '';
    }


    if (typeof image === 'object') {

      image =
        image.src ||
        image.url ||
        '';

    }


    if (!image) {
      return '';
    }


    try {

      const url =
        new URL(
          image,
          window.location.origin
        );


      url.searchParams.set(
        'width',
        '500'
      );


      return url.toString();

    } catch {

      return image;

    }

  }


  function createCard(product, index) {

    const card =
      document.createElement('a');


    card.className =
      'sbc-cart-curation__card';


    card.href =
      product.url;



    const media =
      document.createElement('div');


    media.className =
      'sbc-cart-curation__media';



    const src =
      imageUrl(product);


    if (src) {

      const img =
        document.createElement('img');


      img.className =
        'sbc-cart-curation__img';


      img.src =
        src;


      img.alt =
        product.title || 'SoulByChi';


      img.loading =
        'lazy';


      media.appendChild(img);

    }



    const body =
      document.createElement('div');


    body.className =
      'sbc-cart-curation__body';



    const label =
      document.createElement('div');


    label.className =
      'sbc-cart-curation__card-label';


    label.textContent =
      index === 0
        ? 'SOULBYCHI / SEÇİM'
        : 'TAMAMLAYICI PARÇA';



    const title =
      document.createElement('div');


    title.className =
      'sbc-cart-curation__card-title';


    title.textContent =
      product.title;



    const price =
      document.createElement('div');


    price.className =
      'sbc-cart-curation__card-price';


    price.textContent =
      money(product.price);



    const copy =
      document.createElement('div');


    copy.className =
      'sbc-cart-curation__card-copy';


    copy.textContent =
      description(product);



    const link =
      document.createElement('div');


    link.className =
      'sbc-cart-curation__card-link';


    link.textContent =
      'İncele ↗';



    body.append(
      label,
      title,
      price,
      copy,
      link
    );


    card.append(
      media,
      body
    );


    return card;

  }


  async function refresh() {

    if (running) {
      return;
    }


    const grid =
      document.querySelector(
        GRID_SELECTOR
      );


    if (!grid) {
      return;
    }


    running = true;


    try {

      const cart =
        await getCart();


      if (
        !cart.items ||
        cart.items.length === 0
      ) {
        return;
      }



      /*
       * Sepette bulunan ürün ID'leri.
       */

      const cartIds =
        new Set(
          cart.items.map(
            item =>
              String(item.product_id)
          )
        );



      /*
       * Sepetteki ilk 3 farklı üründen
       * Shopify önerileri toplanır.
       */

      const sourceIds =
        [
          ...cartIds
        ].slice(0, 3);



      const groups =
        await Promise.all(
          sourceIds.map(
            id =>
              getRecommendations(id)
          )
        );



      const candidates =
        new Map();



      groups.forEach(
        products => {

          products.forEach(
            (product, rank) => {

              const id =
                String(product.id);


              /*
               * Sepette zaten bulunan ürünü gösterme.
               */

              if (cartIds.has(id)) {
                return;
              }


              /*
               * Tükendiyse gösterme.
               */

              if (
                product.available === false
              ) {
                return;
              }


              /*
               * Görselsiz ürün gösterme.
               */

              if (!product.featured_image) {
                return;
              }


              const existing =
                candidates.get(id);


              if (existing) {

                /*
                 * Birden fazla sepet ürünüyle
                 * ilişkiliyse puanı yükselir.
                 */

                existing.score +=
                  10 - rank;

              } else {

                candidates.set(
                  id,
                  {
                    product,
                    score:
                      20 - rank
                  }
                );

              }

            }
          );

        }
      );



      const ranked =
        Array
          .from(
            candidates.values()
          )
          .sort(
            (a, b) =>
              b.score - a.score
          )
          .map(
            item =>
              item.product
          );


      if (
        ranked.length === 0
      ) {
        return;
      }



      /*
       * Sepet değiştikçe seçim başlangıcı da değişsin.
       * Böylece sürekli aynı ilk iki ürün görünmez.
       */

      const seed =
        sourceIds.reduce(
          (total, id) =>
            total +
            Number(
              id.slice(-5)
            ),
          cart.item_count || 0
        );


      const start =
        seed %
        ranked.length;



      const selected =
        [];


      for (
        let i = 0;
        i < ranked.length &&
        selected.length < 2;
        i++
      ) {

        const product =
          ranked[
            (start + i) %
            ranked.length
          ];


        if (
          !selected.some(
            selectedProduct =>
              selectedProduct.id ===
              product.id
          )
        ) {

          selected.push(product);

        }

      }



      if (!selected.length) {
        return;
      }


      grid.replaceChildren(
        ...selected.map(
          (product, index) =>
            createCard(
              product,
              index
            )
        )
      );


      grid.dataset.sbcRecommendations =
        'loaded';


    } catch (error) {

      console.warn(
        '[SoulByChi recommendations]',
        error
      );

    } finally {

      running = false;

    }

  }


  function schedule() {

    clearTimeout(timer);


    timer =
      setTimeout(
        refresh,
        250
      );

  }



  /*
   * İlk sayfa yüklemesi.
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      schedule,
      {
        once: true
      }
    );

  } else {

    schedule();

  }



  /*
   * Shopify ürün ekleme/silme/adet değişimi tamamlandığında
   * SADECE önerileri tekrar hesapla.
   *
   * Sepete müdahale etmiyoruz.
   */

  document.addEventListener(
    'shopify:cart:lines-update',
    event => {

      if (
        event.promise &&
        typeof event.promise.then === 'function'
      ) {

        event.promise
          .then(
            () =>
              setTimeout(
                schedule,
                250
              )
          )
          .catch(
            () => {}
          );

      } else {

        setTimeout(
          schedule,
          350
        );

      }

    }
  );



  /*
   * Sepet ikonuna tıklanınca da önerileri kontrol et.
   */

  document.addEventListener(
    'click',
    event => {

      if (
        event.target.closest(
          '.sbc-cart-link, [href="/cart"], [href$="/cart"]'
        )
      ) {

        setTimeout(
          schedule,
          350
        );

      }

    }
  );

})();